import { StyleSheet } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  titleContainerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  titleStyle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
  },
  finishedTitleTextStyle: theme => ({
    color: theme.colors.headerTitleColor,
  }),
  activeTitleTextStyle: theme => ({
    ...Fonts.type.bold,
    marginLeft: -1,
    color: theme.colors.headerTitleColor,
  }),
  notInitiatedTitleTextStyle: theme => ({
    color: theme.colors.textColorTwo,
  }),
})
